import React, { useRef } from 'react';

export default function OtpInput({ value, onChange, length = 6, autoFocus = true, testId }) {
    const refs = useRef([]);
    const arr = Array.from({ length }, (_, i) => value[i] || '');

    const handleChange = (i, v) => {
        const ch = (v || '').replace(/\D/g, '').slice(-1);
        const next = arr.slice();
        next[i] = ch;
        const joined = next.join('').slice(0, length);
        onChange(joined);
        if (ch && i < length - 1) refs.current[i + 1]?.focus();
    };

    const handleKey = (i, e) => {
        if (e.key === 'Backspace' && !arr[i] && i > 0) refs.current[i - 1]?.focus();
    };

    const handlePaste = (e) => {
        const text = (e.clipboardData || window.clipboardData).getData('text');
        const cleaned = (text || '').replace(/\D/g, '').slice(0, length);
        if (!cleaned) return;
        e.preventDefault();
        onChange(cleaned);
        const idx = Math.min(cleaned.length, length - 1);
        refs.current[idx]?.focus();
    };

    return (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }} data-testid={testId}>
            {arr.map((d, i) => (
                <input
                    key={`slot-${i}`}
                    ref={(el) => (refs.current[i] = el)}
                    className="otp-slot"
                    inputMode="numeric"
                    maxLength={1}
                    value={d}
                    onChange={(e) => handleChange(i, e.target.value)}
                    onKeyDown={(e) => handleKey(i, e)}
                    onPaste={handlePaste}
                    autoFocus={autoFocus && i === 0}
                />
            ))}
        </div>
    );
}
